import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';

interface ConfirmHeaderProps {
  title: string;
  subtitle: string;
  iconColor?: string;
  mb?: number;
}

const ConfirmHeader: React.FC<ConfirmHeaderProps> = ({
  title,
  subtitle,
  iconColor,
  mb = 2,
}) => {
  const theme = useTheme();
  const smScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const formatSubtitle = (text: string) => {
    return text.split('. ').map((part, index, array) => (
      <React.Fragment key={index}>
        {part}
        {index < array.length - 1 && <br />}
      </React.Fragment>
    ));
  };

  return (
    <Box ml={4} mt={2.5} mb={mb}>
      <Box display="flex" alignItems="center" mb={1}>
        <Box
          component="i"
          className="bx bx-error-circle"
          sx={{
            fontSize: '24px',
            color: iconColor,
            mr: 2,
          }}
        />
        <Typography
          fontFamily="Lufga"
          fontWeight="500"
          fontSize="24px"
          color="var(--primary-navy)"
        >
          {title}
        </Typography>
      </Box>
      <Box
        sx={{ borderBottom: '1px solid var(--border)', mb: 3, width: '500px' }}
      />

      <Typography
        fontFamily="Outfit"
        fontWeight="400"
        fontSize="16px"
        color="var(--primary-navy)"
      >
        {formatSubtitle(subtitle)}
      </Typography>
    </Box>
  );
};

export default ConfirmHeader;
